import React, { useState } from "react";
import RoomBookingSearchForm from "./RoomBookingSearchForm";
import RestaurantBookingSearchForm from "./RestaurantBookingSearchForm";

const BookingSearchPage = () => {
  const [activeTab, setActiveTab] = useState("rooms");
  const [searchResults, setSearchResults] = useState(null);

  const handleRoomSearch = (searchData) => {
    setSearchResults({
      type: "room",
      data: searchData,
      timestamp: new Date().toLocaleString(),
    });

    // Here you would typically make an API call to search for rooms
    // Example: searchRooms(searchData).then(results => setSearchResults(results));
  };

  const handleRestaurantSearch = (searchData) => {
    setSearchResults({
      type: "restaurant",
      data: searchData,
      timestamp: new Date().toLocaleString(),
    });

    // Here you would typically make an API call to search for restaurants
    // Example: searchRestaurants(searchData).then(results => setSearchResults(results));
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50">
      {/* Navigation Tabs */}
      <div className="bg-white shadow-sm">
        <div className="max-w-6xl mx-auto px-4">
          <div className="flex space-x-0">
            <button
              onClick={() => setActiveTab("rooms")}
              className={`px-8 py-4 font-semibold text-lg transition-all duration-300 border-b-4 ${
                activeTab === "rooms"
                  ? "text-blue-600 border-blue-600 bg-blue-50"
                  : "text-gray-600 border-transparent hover:text-blue-500 hover:border-blue-300"
              }`}
            >
              🏨 Room Booking
            </button>
            <button
              onClick={() => setActiveTab("restaurants")}
              className={`px-8 py-4 font-semibold text-lg transition-all duration-300 border-b-4 ${
                activeTab === "restaurants"
                  ? "text-red-600 border-red-600 bg-red-50"
                  : "text-gray-600 border-transparent hover:text-red-500 hover:border-red-300"
              }`}
            >
              🍽️ Restaurant Booking
            </button>
          </div>
        </div>
      </div>

      {/* Content Area */}
      <div className="py-8">
        {activeTab === "rooms" && (
          <RoomBookingSearchForm onSearch={handleRoomSearch} />
        )}

        {activeTab === "restaurants" && (
          <RestaurantBookingSearchForm
            onSearch={handleRestaurantSearch}
            openingTime="10:00 AM"
            closingTime="11:00 PM"
          />
        )}
      </div>

      {/* Search Results Display (for demo purposes) */}
      {searchResults && (
        <div className="max-w-4xl mx-auto px-6 pb-8">
          <div className="bg-white rounded-2xl shadow-lg p-6 border-l-4 border-green-500">
            <h3 className="text-xl font-bold text-green-600 mb-3">
              ✅ Search Completed Successfully!
            </h3>
            <div className="bg-gray-50 rounded-xl p-4">
              <p className="text-sm text-gray-600 mb-2">
                <strong>Search Type:</strong>{" "}
                {searchResults.type === "room"
                  ? "Room Booking"
                  : "Restaurant Booking"}
              </p>
              <p className="text-sm text-gray-600 mb-2">
                <strong>Timestamp:</strong> {searchResults.timestamp}
              </p>
              <p className="text-sm text-gray-600 mb-3">
                <strong>Search Parameters:</strong>
              </p>
              <pre className="bg-white p-3 rounded-lg text-sm text-gray-800 overflow-auto">
                {JSON.stringify(searchResults.data, null, 2)}
              </pre>
            </div>
            <div className="mt-4 text-sm text-gray-500">
              💡{" "}
              <em>
                In a real application, this would trigger a search API call and
                display actual results.
              </em>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BookingSearchPage;
